import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import {
  ContUseCasesPage,
  ContInfoUseCasesPage,
  ContSecondaryBtnTitle,
  ContBtnTitle,
  ContBtnTitle2,
  BtnTitle,
  DescUseCases,
  ContButton,
  ContainerResolve,
  ContainerResolveTitle,
  ContainerCarrousel,
  ContInfoModulesPage,
  ContModulesTabs,
  TiltleModules2,
  TiltleModules3,
  TiltleModules4,
  TiltleModules6,
  SubTiltleModules,
  ContIntegrations,
  ContItemsClients,
  ContainerColumnsCredit,
  ContButtonsCompanies,
  ButtonCompanie,
  Icon,
  ContInfoContactPage,
  ContTitleContact,
  TitleContact,
  SubtitleContact,
} from './UseCasesPage.styles';
import UseCasesImagesContainer from '../../components/useCasesImagesContainer';
import ModulesTabs from '../../components/ModulesTabs';
import TitleSpecial from '../../components/TitleSpecial';
import ButtonSpecial from '../../components/ButtonSpecial';
import ClientCarousel from '../../components/ClientsCarousel';
import CardSlider from '../../components/CardSlider';
import Card from '../../assets/images/UseCases/card-icon.png';
import Money from '../../assets/images/UseCases/money-icon.png';
import Wallet from '../../assets/images/UseCases/wallet-icon.png';
import Finance from '../../assets/images/UseCases/finance-icon.png';
import AccessTimeFilledRoundedIcon from '@mui/icons-material/AccessTimeFilledRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FormContact from '../../components/FormContact';
import backImage from '../../assets/images/use-caseform-back.png';

export const UseCasesPage = () => {
  const { t } = useTranslation();

  const cards = [
    {
      title: t('Mala experiencia del cliente'),
      description: t('La lentitud de los procesos y la complejidad en la solicitud de documentación lleva al cliente a perder interés en completar la solicitud de servicio.'),
      icon: <AccessTimeFilledRoundedIcon fontSize="inherit" />,
    },
    {
      title: t('Clientes morosos'),
      description: t('La ausencia de una evaluación de riesgos adecuada y de un seguimiento eficiente puede resultar en préstamos incobrables o en la exclusión de personas no bancarizadas.'),
      icon: <PersonRoundedIcon fontSize="inherit" />,
    },
    {
      title: t('Cumplimiento normativo'),
      description: t('Falta de métodos para verificación de identidad del solicitante y la prevención del lavado de dinero.'),
      icon: <AssignmentRoundedIcon fontSize="inherit" />,
    },
  ];

  const cardsTexts = [
    {
      title: t('Configurable y escalable'),
      icon: <SettingsRoundedIcon fontSize="inherit" />,
      description: t('Diseñamos una plataforma que se adapta 100% a tu estrategia.'),
    },
    {
      title: t('Experiencia en el sector'),
      icon: <VerifiedRoundedIcon fontSize="inherit" />,
      description: t('Llevamos más de tres años especializándonos en la automatización y digitalización de financieras del país.'),
    },
    {
      title: t('Seguridad y cumplimiento'),
      icon: <LockOutlinedIcon fontSize="inherit" />,
      description: t('Cumplimos con los más altos estándares de seguridad, así como la normativa requerida por las instituciones financieras y fiscales.'),
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={'container-fit'} id={'container-fit'}>
      <ContUseCasesPage id={'ContUseCasesgPage'}>
        <ContInfoUseCasesPage>
          <ContBtnTitle>
            <BtnTitle>{t('Caso de Uso: Crédito')}</BtnTitle>
          </ContBtnTitle>
          <TitleSpecial useCasesView={true}>
            {t('Revoluciona tu flujo de aprobación de créditos')}
          </TitleSpecial>
          <DescUseCases>
            {t('Fortalece el proceso de aprobación de crédito ayudando a tomar decisiones de manera ágil y efectiva, permitiendo registrar a un mayor número de clientes y una gestión de riesgos más eficaz.')}
          </DescUseCases>
          <ContButton id={'ContButton'}>
            <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'primary'} />
          </ContButton>

          <UseCasesImagesContainer useSeparates={false} />
        </ContInfoUseCasesPage>

        <ContainerResolve id={'ContainerResolve'}>
          <ContSecondaryBtnTitle>
            <ContBtnTitle2>
              <BtnTitle secondary={true}>{t('Problemática')}</BtnTitle>
            </ContBtnTitle2>
          </ContSecondaryBtnTitle>
          <ContainerResolveTitle>
            <TiltleModules2 white={true}>{t('Resuelve los desafíos del sector')}</TiltleModules2>
            <SubTiltleModules white={true}>
              {t('Nuestra plataforma ofrece soluciones efectivas a los siguientes problemas:')}
            </SubTiltleModules>
          </ContainerResolveTitle>
          <ContainerCarrousel>
            <CardSlider cards={cards} />
          </ContainerCarrousel>
        </ContainerResolve>

        <ContInfoModulesPage>
          <ContBtnTitle2>
            <BtnTitle secondary={true}>{t('Nuestra solución')}</BtnTitle>
          </ContBtnTitle2>
          <TiltleModules3>
            {t('Eficienta procesos con los mejores módulos')}
          </TiltleModules3>
          <SubTiltleModules>
            {t('Serán tus mejores aliados para la captación de clientes, aprobación y gestión de crédito')}
          </SubTiltleModules>
          <ContModulesTabs>
            <ModulesTabs />
          </ContModulesTabs>
        </ContInfoModulesPage>

        <ContIntegrations>
          <TiltleModules4>
            {t('Nuestras integraciones')}
          </TiltleModules4>
          <ContItemsClients>
            <ClientCarousel />
          </ContItemsClients>
        </ContIntegrations>

        <ContainerResolve>
          <ContSecondaryBtnTitle>
            <ContBtnTitle>
              <BtnTitle secondary={true}>{t('Valor Agregado')}</BtnTitle>
            </ContBtnTitle>
          </ContSecondaryBtnTitle>
          <ContainerResolveTitle>
            <TiltleModules6 white={true}>{t('Somos el socio ideal para tu entidad financiera')}</TiltleModules6>
            <SubTiltleModules white={true}>
              {t('Nuestra propuesta se destaca por su eficiencia y reducción de riesgos. Ofrecemos una plataforma configurable que simplifica la creación de productos financieros y respaldamos a cada cliente con un soporte personalizado')}
            </SubTiltleModules>
          </ContainerResolveTitle>
          <ContainerCarrousel marginBottom={true}>
            <CardSlider cards={cardsTexts} />
          </ContainerCarrousel>
        </ContainerResolve>

        <ContIntegrations>
          <ContBtnTitle>
            <BtnTitle secondary={true}>{t('Modelos de negocio')}</BtnTitle>
          </ContBtnTitle>
          <TiltleModules6>
            {t('¿A qué empresas ayudamos?')}
          </TiltleModules6>
          <SubTiltleModules width={70}>
            {t('Nuestra plataforma ayuda a financieras tradicionales o en crecimiento que desean automatizar su operación y crear productos financieros digitales.')}
          </SubTiltleModules>
          <ContButtonsCompanies>
            <ButtonCompanie>
              SOFOMES<Icon><img src={Card} alt={'sofomes imagen'} /></Icon>
            </ButtonCompanie>
            <ButtonCompanie>
              SOFIPOS<Icon><img src={Money} alt={'Sofipos imagen'} /></Icon>
            </ButtonCompanie>
            <ButtonCompanie>
              FINTECHS<Icon><img src={Wallet} alt={'FINTECH imagen'} /></Icon>
            </ButtonCompanie>
            <ButtonCompanie>
              {t('Financieras')}<Icon><img src={Finance} alt={'Financieras imagen'} /></Icon>
            </ButtonCompanie>
          </ContButtonsCompanies>
        </ContIntegrations>

        <ContInfoContactPage>
          <ContainerColumnsCredit>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                order={{ xs: 1, sm: 1, md: 1 }}
                sx={{
                  backgroundImage: `url(${backImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <ContTitleContact>
                  <TitleContact>
                    {t('Queremos ayudarte a despegar tu proyecto 🚀')}
                  </TitleContact>
                  <SubtitleContact>
                    {t('¡Compártenos detalles y comencemos a trabajar juntos!')}
                  </SubtitleContact>
                </ContTitleContact>
              </Grid>
              <Grid item xs={12} sm={12} md={6} order={{ xs: 2, sm: 2, md: 2 }}>
                <FormContact />
              </Grid>
            </Grid>
          </ContainerColumnsCredit>
        </ContInfoContactPage>
      </ContUseCasesPage>
    </div>
  );
};
